import React from "react";
import filterFields from "../../../../utils/filterFields";

const defaultProps = {
  schemas: [],
};

function OutputPointer({ field, fields, object, target, schemas, indexes }) {
  const schema = schemas.find((s) => s.collection === target) || {};

  const getIndex = () => {
    const _fields = fields || schema.fields || {};
    const items = filterFields(_fields, "_index");
    return items.length > 0 ? items : ["name"];
  };
  const _indexes = indexes || getIndex();

  const pointer = object[field];
  if (pointer) {
    return _indexes.map((index) => pointer[index]).join(" ");
  }
  return null;
}

OutputPointer.defaultProps = defaultProps;

export default React.memo(OutputPointer);
